<app-modal #modal class="assign-patient-modal">
  <div class="modal-header">
    <h2 class="modal-title">Assign Patient to Trial</h2>
  </div>
  <div class="modal-body">
    <form (submit)="onFormSubmit()" [formGroup]="form">

      <table aria-hidden="true" class="patient-trial">
        <tr>
          <th style="width: 115px;"><label>Trial <sup>*</sup></label></th>
          <td>
            <div class="form-group">
              <span class="fake-field disabled">{{ form.get('trialCode').value }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <th><label>Site <sup>*</sup></label></th>
          <td>
            <div class="form-group">
              <app-site-dropdown
                formControlName="siteId"
                [trialId]="this.form.get('trialId').value"
                [trialIdRequired]="true"
                [assignedOnly]="true"
                [unassignedOnly]="false"
                [approvedOnly]="true" />
            </div>
          </td>
        </tr>
        <tr>
          <th><label>Patient <sup>*</sup></label></th>
          <td>
            <div class="form-group">
              <app-patient-autocomplete #patientAutocomplete [parentForm]="form"
                                        placeholder="Start typing to find patient..."
                                        [globalOnly]="!trial.isThirdParty"
                                        [apiConsumerIds]="trial.isThirdParty ? trial.apiConsumerIds : []"
                                        controlName="patientId"></app-patient-autocomplete>
            </div>
            <div style="margin-bottom: 20px;">
              <app-button text="+ Add New Patient" variant="info" size="sm" (clicked)="addPatientModal.show(form.get('trialId').value)" />
            </div>
          </td>
        </tr>
        <tr *ngIf="patient !== undefined && patient !== null">
          <th><label>First Name</label></th>
          <td>
            <div class="form-group">
              <span class="fake-field disabled">{{ patient.firstname }}</span>
            </div>
          </td>
        </tr>
        <tr *ngIf="patient !== undefined && patient !== null">
          <th><label>Last Name</label></th>
          <td>
            <div class="form-group">
              <span class="fake-field disabled">{{ patient.lastname }}</span>
            </div>
          </td>
        </tr>
        <tr *ngIf="patient !== undefined && patient !== null">
          <th><label>Email</label></th>
          <td>
            <div class="form-group">
              <span class="fake-field disabled">{{ patient.email }}</span>
            </div>
          </td>
        </tr>
        <tr *ngIf="patient !== undefined && patient !== null">
          <th><label>Country</label></th>
          <td>
            <div class="form-group">
              <span class="fake-field disabled">{{ patient.country }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <th><label for="patientCode">Patient Id <sup>*</sup></label></th>
          <td>
            <div class="form-group">
              <input class="form-control" formControlName="patientCode" id="patientCode" type="text">
            </div>
          </td>
        </tr>
        <tr>
          <th></th>
          <td>
            <div class="checkbox-wrap last">
              <div class="form-group">
                <label class="checkbox">
                  <input formControlName="consent" id="consent" type="checkbox">
                  <span></span>
                </label>
                <label class="checkbox-label" for="consent">I confirm that I have seen and verified patient
                  consent</label>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <th></th>
          <td class="buttons" style="text-align: right;">
            <div class="row" style="margin-bottom: 30px;">
              <div class="col-6">
                <app-button text="Cancel" variant="secondary" width="fill" (clicked)="hide()" />
              </div>
              <div class="col-6">
                <app-button text="Add Patient" type="submit" width="fill" [disabled]="!form.valid || form.get('processing').value" [isBusy]="form.get('processing').value" />
              </div>
            </div>
          </td>
        </tr>
      </table>

    </form>
  </div>
</app-modal>

<app-patient-add-modal #addPatientModal (patientCreated)="onHandlePatientCreated($event)"></app-patient-add-modal>
